import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, EmptyState, fmtDateTime } from "@/components/common";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Activity, AlertTriangle, Smartphone } from "lucide-react";

const MODULES = ["all", "auth", "orders", "temperature", "cleaning", "prep", "checklists", "staff", "settings"];

export default function ActivityLog() {
  const [logs, setLogs] = useState([]);
  const [staff, setStaff] = useState([]);
  const [module, setModule] = useState("all");
  const [userId, setUserId] = useState("all");

  const load = async () => {
    try {
      const q = [];
      if (module !== "all") q.push(`module=${module}`);
      if (userId !== "all") q.push(`user_id=${userId}`);
      setLogs((await api.get(`/activity${q.length ? "?" + q.join("&") : ""}`)).data);
    } catch { /* handled by route guard */ }
  };
  useEffect(() => { api.get("/staff").then((r) => setStaff(r.data)).catch(() => {}); }, []);
  useEffect(() => { load(); }, [module, userId]);

  return (
    <div>
      <PageHeader title="Activity & Accountability" subtitle="Who did what, when — every meaningful action." testid="activity-header" />

      <div className="flex gap-3 mb-5 flex-wrap">
        <Select value={module} onValueChange={setModule}><SelectTrigger className="w-44" data-testid="filter-module"><SelectValue /></SelectTrigger>
          <SelectContent>{MODULES.map((m) => <SelectItem key={m} value={m} className="capitalize">{m === "all" ? "All modules" : m}</SelectItem>)}</SelectContent></Select>
        <Select value={userId} onValueChange={setUserId}><SelectTrigger className="w-44" data-testid="filter-user"><SelectValue /></SelectTrigger>
          <SelectContent><SelectItem value="all">All staff</SelectItem>{staff.map((s) => <SelectItem key={s.user_id} value={s.user_id}>{s.name}</SelectItem>)}</SelectContent></Select>
      </div>

      {logs.length === 0 ? <EmptyState icon={Activity} title="No activity found." /> :
        <div className="cc-card divide-y divide-slate-100" data-testid="activity-list">
          {logs.map((a) => {
            const exception = a.action.includes("exception") || a.action.includes("failed");
            return (
              <div key={a.log_id} className="p-4 flex items-start gap-3" data-testid={`log-${a.log_id}`}>
                <div className={`h-9 w-9 rounded-full flex items-center justify-center text-xs font-bold shrink-0 ${exception ? "bg-red-100 text-red-600" : "bg-brand-light text-brand-dark"}`}>
                  {exception ? <AlertTriangle size={16} /> : (a.user_name || "?")[0]}
                </div>
                <div className="min-w-0 flex-1">
                  <div className={`text-sm ${exception ? "text-red-700 font-medium" : "text-slate-700"}`}>{a.summary}</div>
                  <div className="text-[11px] text-slate-400 mt-0.5 flex items-center gap-1.5 flex-wrap"><span className="capitalize">{a.module}</span> · {fmtDateTime(a.timestamp)}{a.metadata?.source === "ios_app_intent" && <span data-testid={`log-source-${a.log_id}`} className="inline-flex items-center gap-1 text-[10px] font-semibold px-1.5 py-0.5 rounded bg-slate-100 text-slate-600"><Smartphone size={10} /> iPhone / Siri</span>}</div>
                </div>
              </div>
            );
          })}
        </div>}
    </div>
  );
}
